module.exports = __webpack_public_path__ + "static/media/type-7.0863ed40.svg";